import './index.less'
import { getGoodsRecommend, shopifyCartAdd } from "@utils/api.js";

document.addEventListener('DOMContentLoaded', function () {
  if(!customElements.get('jky-v5-app-recommend-products')) {
    customElements.define('jky-v5-app-recommend-products', class JkyV5AppRecommendProducts extends HTMLElement {
      constructor() {
        super();
        this.isMobile = window.innerWidth < 1024;
        this.variantId = this.getAttribute('data-variant-id') || '';
      }
      connectedCallback() {
        this.innerHTML = this.renderSkeleton();
        this.init();

        // 新 main-product 触发variant变化 - 改变当前变体
        if (document.querySelector('variant-fields')) {
          document.addEventListener('variantChangeEvent', e => {
            const currentVariant = e.detail.variant
            if (currentVariant) {
              this.variantId = currentVariant.id
              this.innerHTML = this.renderSkeleton();
              this.init()
            }
          })
        }
      }
      disconnectedCallback() {
        this.swiper?.destroy()
        this.swiper = null
      }
      async init() {
        try {
          const { data } = await getGoodsRecommend({ skuId: this.variantId,version: 5});
          if (data.goods && data.goods.length > 0) {
            this.style.display = 'block'
            this.innerHTML = this.renderDOM(data);
            this.initSwiper(data.goods);
            this.initEvent();
          } else {
            // 如果没有推荐商品，隐藏组件并清空内容
            this.style.display = 'none'
            this.innerHTML = ''
          }
        } catch(err) {
          console.error(err)
          this.style.display = 'none'
          this.innerHTML = ''
        }
      }
      // 渲染骨架屏
      renderSkeleton() {
        return `
          <h2 class="w-72 h-7 lg:w-60 bg-[#EEE] skeleton"></h2>
          <h4 class="w-36 h-[1.125rem] mt-1 lg:w-30 lg:h-6 lg:mt-1.5 bg-[#EEE] skeleton"></h4>
          <ul class="w-full flex gap-x-3 lg:gap-x-5 mt-4 lg:mt-6 overflow-hidden">
            ${this.renderItemSkeleton()}
          </ul>
        `
      }
      renderItemSkeleton() {
        let html = '';
        html = Array.from({ length: 3 }, () => (`
          <li class="flex-shrink-0 w-[17.5rem] lg:w-60 overflow-hidden">
            <div class="w-[17.5rem] h-[13.125rem] lg:w-60 lg:h-[11.25rem] bg-[#EEE] skeleton"></div>
            <div class="flex flex-col w-full items-start mt-4">
              <div class="flex flex-col w-full h-[3rem] lg:h-[3.5rem] gap-y-1">
                <p class="w-full h-5 bg-[#EEE] lg:h-6 skeleton"></p>
                <p class="w-3/5 h-5 bg-[#EEE] lg:h-6 skeleton"></p>
              </div>
              <p class="w-full flex flex-col justify-start gap-y-1 mt-3 h-[2rem] lg:h-[2.5rem]">
                <span class="block w-[90%] h-3 lg:h-4 bg-[#EEE] skeleton"></span>
                <span class="block w-[70%] h-3 lg:h-4 bg-[#EEE] skeleton"></span>
              </p>
              <div class="flex items-center justify-between w-full mt-4">
                <div class="w-1/2 h-6 bg-[#EEE] skeleton"></div>
                <div class="w-7 h-7 lg:w-8 lg:h-8 bg-[#EEE] skeleton"></div>
              </div>
            </div>
          </li>
        `)).join('')

        return html
      }
      // 渲染 DOM
      renderDOM({ title, subTitle, goods = [] }) {
        const sku_card_bg = this.getAttribute("data-sku-card-bg")
        // 是否开启了 自动折扣价
        const open_auto_discount_price = this.getAttribute("data-open-auto-discount-price") === "true"
        // 折扣角标
        const data_discount_tag_display_style = this.getAttribute("data-discount-tag-display-style")
        const discount_amount_display_style = this.getAttribute("data-discount-amount-display-style")
        const discount_percent_display_style = this.getAttribute("data-discount-percent-display-style")
        return `
          ${title
            ? `<h2 class="font-semibold text-[#242F20] text-xl lg:text-2xl">${title}</h2>`
            : ''
          }
          ${subTitle
            ? `<h4 class="font-normal text-xs text-[#242F20]/65 lg:text-base mt-1 lg:mt-1.5">${subTitle}</h4>`
            : ''
          }
          <!-- Swiper -->
          <div class="swiper w-full mt-4 pb-8 lg:mt-6 lg:pb-0 relative">
            <div class="swiper-wrapper">
              ${this.renderSlides({ sku_card_bg, open_auto_discount_price, data_discount_tag_display_style, discount_amount_display_style, discount_percent_display_style, goods })}
            </div>
            <div class="w-full h-1 flex items-center justify-center gap-x-1 !bottom-0 lg:hidden swiper-pagination swiper-app-recommend-products-pagination"></div>
          </div>
          <div class="hidden lg:flex swiper-button-prev swiper-app-recommend-products-prev opacity-0"></div>
          <div class="hidden lg:flex swiper-button-next swiper-app-recommend-products-next opacity-0"></div>
        `
      }
      renderSlides({ sku_card_bg, open_auto_discount_price, data_discount_tag_display_style, discount_amount_display_style, discount_percent_display_style, goods }) {
        const isAllIntroEmpty = goods.every(item => !item.intro)

        let html = '';
        html = goods.map(item => {
          const current_price = Math.min(item.autoDiscountPrice || 0, item.price || 0)
          const origin_price = Math.max(item.autoDiscountPrice || 0, item.price || 0, item.originalPrice || 0)
          let money_format = window?.pageInfo?.currency?.money_format?.replace('{{amount}}', '{{amount_no_decimals}}')
          money_format = money_format?.replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
          const discount_amount = formatMoney(Math.floor(item.autoDiscountAmount / 100) * 100, money_format)

          const imageSrc = item.image.includes('?') ? item.image + '&width=560' : item.image + '?width=560'
          return `
            <div class="swiper-slide w-[17.5rem] lg:w-60 overflow-hidden flex flex-col gap-y-4" data-title="${item.title}">
              <a href="${window.location.origin}/products/${item.handle}?variant=${item.skuId}&action_tag=Recommended" data-type="pic" class="block w-[17.5rem] h-[13.125rem] lg:w-60 lg:h-[11.25rem] relative" style="background-color:${sku_card_bg}">
                <img class="w-full h-full !object-contain" src="${imageSrc}" loading="lazy" />
                ${item.promotion
                  ? `<span class="absolute top-2 left-2 bg-[#F5F5F3] py-1 px-2 text-sm font-semibold text-primary">${item.promotion}</span>`
                  : open_auto_discount_price
                    ? data_discount_tag_display_style === 'amount'
                      ? item.autoDiscountAmount > 0
                        ? `<span class="absolute top-2 left-2 bg-[#F5F5F3] py-1 px-2 text-sm font-semibold text-primary">${discount_amount_display_style.replace('()', discount_amount)}</span>`
                        : ''
                      : item.autoDiscountPercentage > 0
                        ? `<span class="absolute top-2 left-2 bg-[#F5F5F3] py-1 px-2 text-sm font-semibold text-primary">${discount_percent_display_style.replace('()', item.autoDiscountPercentage)}</span>`
                        : ''
                    : ''
                }
              </a>
              <div class="flex flex-col w-full items-start">
                <a
                  href="${window.location.origin}/products/${item.handle}?variant=${item.skuId}&action_tag=Recommended"
                  data-type="text"
                  class="text-base font-semibold text-[#242F20] h-[3rem] lg:text-xl lg:h-[3.5rem] line-clamp-2"
                  title="${item.title}"
                >${item.title}</a>
                ${!isAllIntroEmpty
                  ? `<p class="text-sm h-10 text-black/65 mt-2 line-clamp-2">${(item.intro || '').replace(/\n/g, '<br>')}</p>`
                  : ''
                }
                <div class="w-full flex items-center justify-between mt-4">
                  <p class="flex items-center gap-x-2">
                    ${open_auto_discount_price && item.autoDiscountPrice > 0
                      ? `<span class="text-base font-semibold lg:text-xl text-[#242F20]">${formatMoney(current_price, pageInfo.currency.money_format)}</span>`
                      : `<span class="text-base font-semibold lg:text-xl text-[#242F20]">${formatMoney(item.price, pageInfo.currency.money_format)}</span>`
                    }
                    ${open_auto_discount_price && item.autoDiscountPrice > 0
                      ? `<span class="text-xs lg:text-sm text-[#242F20]/65 line-through">${origin_price > current_price ? formatMoney(origin_price, pageInfo.currency.money_format) : ''}</span>`
                      : `<span class="text-xs lg:text-sm text-[#242F20]/65 line-through">${Number(item.originalPrice || 0) > Number(item.price || 0) ? formatMoney(item.originalPrice, pageInfo.currency.money_format) : ''}</span>`
                    }
                  </p>
                  <button class="jky-v5-button appearance-none bg-primary flex items-center justify-center w-7 h-7 lg:w-8 lg:h-8" data-sku-id="${item.skuId}" data-add-to-cart-btn>
                    <svg class="text-white w-7 h-7 lg:w-8 lg:h-8" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.71484 8.00781H9.65015L11.2313 27.1924H29.5727L34.6183 12.2102H14.3796" stroke="currentColor" stroke-width="2" stroke-linejoin="bevel"/>
                      <path d="M17.0781 18.9531H26.0731" stroke="currentColor" stroke-width="2"/>
                      <path d="M21.5742 23.4453V14.4503" stroke="currentColor" stroke-width="2"/>
                      <path d="M16.5056 30.8516C16.5056 31.9383 15.6247 32.8192 14.538 32.8192C13.4513 32.8192 12.5703 31.9383 12.5703 30.8516" stroke="currentColor" stroke-width="2"/>
                      <path d="M28.2009 30.8516C28.2009 31.9383 27.32 32.8192 26.2333 32.8192C25.1466 32.8192 24.2656 31.9383 24.2656 30.8516" stroke="currentColor" stroke-width="2"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          `
        }).join('')

        return html
      }
      // 初始化 swiper
      initSwiper(goods) {
        this.swiper?.destroy()
        this.swiper = null

        const prevBtn = this.querySelector('.swiper-app-recommend-products-prev')
        const nextBtn = this.querySelector('.swiper-app-recommend-products-next')

        this.swiper = new Swiper(this.querySelector('.swiper'), {
            slidesPerView: 'auto',
            spaceBetween: this.isMobile ? 16 : 24,
            navigation: {
              prevEl: prevBtn,
              nextEl: nextBtn,
            },
            pagination: goods.length > 2 ? {
              el: '.swiper-app-recommend-products-pagination',
              type: 'bullets', // 明确指定分页类型为 bullets
              clickable: true,
              bulletClass: 'swiper-pagination-item',
              bulletActiveClass: 'swiper-pagination-item-active',
              modifierClass: 'swiper-pagination-',
              renderBullet: function (index, className) {
                return `<span class="${className}"></span>`;
              },
            } : false,
        });

        // 更新 左右箭头状态
        requestAnimationFrame(() => {
          prevBtn.classList.remove('opacity-0')
          nextBtn.classList.remove('opacity-0')
        })
      }
      initEvent() {
        // 监听 a 链接，点击事件
        this.querySelectorAll('a').forEach(a => {
          a.addEventListener('click', (e) => {
            gaPushDataLayer('5.0_products_details_page_user_clicks', {
              product_spu_name: this.getAttribute('data-product-title'), // 识别页面产品spu标题名称text
              module: "Recommend Product Display", // 固定名称Parameter
              position: e.currentTarget.closest('.swiper-slide').getAttribute('data-title'), // 识别配置产品sku名称 text
              button_name: e.currentTarget.getAttribute('data-type'), // pic 或 text
              link: e.currentTarget.getAttribute('href'), // 跳转链接
            })
          })
        })

        // 监听 button 点击事件
        this.querySelectorAll('button[data-add-to-cart-btn]').forEach(button => {
          button.addEventListener('click', async (e) => {
            const target = e.currentTarget
            // loading
            target.classList.add('loading')

            const skuId = target.getAttribute('data-sku-id');

            // 触发添加到购物车的事件
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            try {
              const data = await shopifyCartAdd({ items: [{ id: Number(skuId), quantity: 1, properties: { Action: 'Recommended' } }] });
              if(cart) {
                cart.renderContents(data)
              } else {
                window.location.href = '/cart'
              }
            } catch(err) {
              console.error(err)
            } finally {
              // 移除loading
              target.classList.remove('loading')

              // 数据埋码
              gaPushDataLayer('5.0_products_details_page_user_clicks', {
                product_spu_name: this.getAttribute('data-product-title'), //识别页面产品spu标题名称text
                module: "Recommend Product Display", //固定名称"Recommend Product Display
                position: target.closest('.swiper-slide').getAttribute('data-title'), //识别配置产品sku名称 text
                button_name: "AddToCart", // 固定AddToCart
              })
            }
          })
        })
      }
    })
  }
})
